import React, { useEffect, useState } from 'react';
import styles from './register.module.css';
import { industryList } from '../../../action/auth';
import NumberFormat from 'react-number-format';

const StepThree = ({ prevStep, onSubmit }) => {
    const [state, setState] = useState({
        company_category: { name: 'company_category', value: 'CONSULTANT', error: '', isRequired: true },
        company_name: { name: 'company_name', value: '', error: '', isRequired: true },
        industry: { name: 'industry', value: '', options: [], error: '', isRequired: false },
        pin_code: { name: 'pin_code', value: '', error: '', isRequired: true },
        gst: { name: 'gst', value: '', error: '', isRequired: false },
    });

    useEffect(() => {
        const fetchIndustryList = async () => {
            try {
                const res = await industryList();
                if (res.status) {
                    setState(prevState => ({
                        ...prevState,
                        industry: { ...prevState.industry, options: res.result.list },
                    }));
                }
            } catch (error) {
                console.error('Error fetching industry list:', error);
            }
        };

        fetchIndustryList();
    }, []);

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            industry: {
                ...prevState.industry,
                isRequired: prevState.company_category.value === 'COMPANY',
                value: ''
            },
        }));
    }, [state.company_category.value]);

    const handleCategoryChange = value => {
        setState(prevState => ({
            ...prevState,
            company_category: { ...prevState.company_category, value },
        }));
    };

    const validateForm = () => {
        let isValid = true;
        const updatedState = { ...state };

        Object.keys(state).forEach(key => {
            if (state[key].isRequired && !state[key].value.trim()) {
                updatedState[key].error = `${key.replace('_', ' ')} is required.`;
                isValid = false;
            } else {
                updatedState[key].error = '';
            }
        });

        setState(updatedState);
        return isValid;
    };

    const handleSubmit = e => {
        e.preventDefault();
        if (validateForm()) {
            onSubmit({
                company_category: state.company_category.value,
                company_name: state.company_name.value,
                industry: state.industry.value,
                pin_code: state.pin_code.value,
                gst: state.gst.value,
            });
        }
    };

    return (
        <React.Fragment>
            <div className={`${styles['fill-box']} card`}>
                <div className={`${styles['reg-body']} card-body`}>
                    <h5 className={`${styles['reg-title']}`}>Basic Details</h5>
                    <p className={`${styles['reg-text']}`}>
                        Tell us a bit about yourself to create your account and secure it.
                    </p>
                    <div className="d-flex justify-content-between mt-3 mb-2">
                        {['COMPANY', 'CONSULTANT'].map(category => (
                            <button
                                key={category}
                                className={`btn ${state.company_category.value === category ? styles['comp-btn-active'] : styles['comp-btn']
                                    } w-50 me-1`}
                                onClick={() => handleCategoryChange(category)}
                            >
                                {category === 'COMPANY' ? 'Company/Business' : 'Individual/Proprietor'}
                            </button>
                        ))}
                    </div>

                    <form onSubmit={handleSubmit}>
                        {state.company_category.value === 'COMPANY' && (
                            <div className="my-4">
                                <select
                                    id="industry"
                                    className={`${styles['formctm-control']} form-select ${state.industry.error ? 'is-invalid' : ''
                                        }`}
                                    value={state.industry.value}
                                    onChange={e =>
                                        setState(prevState => ({
                                            ...prevState,
                                            industry: { ...prevState.industry, value: e.target.value },
                                        }))
                                    }
                                >
                                    <option value="">Select Industry</option>
                                    {state.industry.options.map(option => (
                                        <option key={option.EMPLOYER_INDUSTRY_ID} value={option.EMPLOYER_INDUSTRY_ID}>
                                            {option.INDUSTRY}
                                        </option>
                                    ))}
                                </select>
                                {state.industry.error && <div className="invalid-feedback">{state.industry.error}</div>}
                            </div>
                        )}

                        <div className="my-4">
                            <input
                                type="text"
                                id="companyName"
                                className={`${styles['formctm-control']} form-control ${state.company_name.error ? 'is-invalid' : ''
                                    }`}
                                placeholder="Company Name"
                                value={state.company_name.value}
                                onChange={e =>
                                    setState(prevState => ({
                                        ...prevState,
                                        company_name: { ...prevState.company_name, value: e.target.value },
                                    }))
                                }
                            />
                            {state.company_name.error && <div className="invalid-feedback">{state.company_name.error}</div>}
                        </div>
                        <div className="my-4">
                            <div className='row'>
                                <div className='col-6'>
                                    <NumberFormat
                                        id="pin_code"
                                        className={`${styles['formctm-control']} form-control ${state.pin_code.error ? 'is-invalid' : ''
                                            }`}
                                        placeholder="Pin Code"
                                        value={state.pin_code.value}
                                        onChange={e =>
                                            setState(prevState => ({
                                                ...prevState,
                                                pin_code: { ...prevState.pin_code, value: e.target.value },
                                            }))
                                        }
                                    />
                                    {state.pin_code.error && <div className="invalid-feedback">{state.pin_code.error}</div>}
                                </div>
                                <div className='col-6'>
                                    <input
                                        type="text"
                                        id="gst"
                                        className={`${styles['formctm-control']} form-control ${state.gst.error ? 'is-invalid' : ''
                                            }`}
                                        placeholder="GST (Optional)"
                                        value={state.gst.value}
                                        onChange={e =>
                                            setState(prevState => ({
                                                ...prevState,
                                                gst: { ...prevState.gst, value: e.target.value },
                                            }))
                                        }
                                    />
                                    {state.gst.error && <div className="invalid-feedback">{state.gst.error}</div>}

                                </div>
                            </div>
                        </div>


                        <div className="d-flex">
                            <button
                                className={`${styles['verify-btn']} w-50 me-1 btn`}
                                type="button"
                                onClick={prevStep}
                            >
                                Previous
                            </button>
                            <button className={`${styles['send-btn']} w-50 ms-1 btn`} type="submit">
                                Next
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default StepThree;
